import React from "react";
import correct from "../img/correct.png";
import popup from "../img/popup.png";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const calculateInstallmentSchedule = (total) => {
  const totalCents = Math.round(total * 100);
  const recurringCents = Math.floor(totalCents / 12);
  const firstPaymentCents = totalCents - recurringCents * 11;

  return {
    firstPayment: formatter.format(firstPaymentCents / 100),
    recurringPayment: formatter.format(recurringCents / 100),
  };
};

const INDIVIDUAL_ANNUAL = 500;
const SCHOOL_ANNUAL = 5000;

export default function Package() {
  const individualInstallments = calculateInstallmentSchedule(INDIVIDUAL_ANNUAL);
  const schoolInstallments = calculateInstallmentSchedule(SCHOOL_ANNUAL);

  return (
    <div className="max-w-7xl mt-14 mx-auto px-4 sm:px-6 lg:px-8 lg:mb-24 mb-10">
      <div className="grid lg:grid-cols-2 gap-24  grid-cols-1 gap-8 relative">
        <div className="absolute top-0 lg:top-[calc(50%-310px)] 2xl:top-[calc(50%-150px)] z-11 right-0 left-[unset] lg:left-[-125px] 2xl:-left-85">
          <a href="/contactUs">
            <img
              src={popup}
              alt="popup"
              className="w-40 sm:w-56 lg:w-65"
            />
          </a>
        </div>
        {/* Individual Pricing Card */}
        <div className="relative border border-gray-200 rounded-lg shadow-md flex flex-col">
          <div
            style={{ width: "80%" }}
            className="absolute text-center pt-[30px] pb-[20px] -top-20 w-[90%] mx-auto left-1/2 -translate-x-1/2 bg-[#F0AA00] z-10 py-4 px-6 "
          >
            <h3
              style={{
                fontFamily: "poppins",
                display: "inline-block",
                paddingTop: "8px",
                paddingLeft: "20px",
                paddingRight: "20px",
                alignSelf: "center",
                textAlign: "center",
              }}
              className="text-[14px] rounded-full text-center text-black bg-white  p-2"
            >
              For Individual Teachers & Caregivers
            </h3>
            <div className="flex mt-3 items-center justify-center lg:gap-6">
              <p style={{ fontFamily: "Fredoka" }} className="lg:text-[54px] text-[28px] font-semibold text-white">
                {formatter.format(INDIVIDUAL_ANNUAL)}
              </p>
            </div>
            <p className="text-white text-sm mt-2 leading-relaxed">
              Or choose 12 monthly payments: first payment {individualInstallments.firstPayment}, next 11 payments{" "}
              {individualInstallments.recurringPayment} (charged every 30 days).
            </p>
          </div>

          <div
            style={{ width: "80%" }}
            className="mx-auto lg:mt-48 mt-36  pb-6  flex-1 flex flex-col justify-between"
          >
            <div>
              <h4
                style={{ fontFamily: "poppins" }}
                className="font-medium text-[24px] mb-4 text-black"
              >
                What's included:
              </h4>
              <ul className="space-y-6 text-base text-gray-700">
                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Full interactive course with scenario-based training
                  </div>
                </li>
                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Required testing and printable certification
                  </div>
                </li>

                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Access for 12 months to refresh as needed
                  </div>
                </li>

                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    No hidden fees. No upcharges. No extra costs
                  </div>
                </li>
              </ul>
            </div>
            <a href={`${process.env.REACT_APP_ADMIN_URL}/individualteacherregister`}>
              <button className="w-full bg-[#F0AA00] hover:bg-yellow-600 text-white font-bold py-3 rounded-md mt-10 text-[19px] transition">
                Sign Up
              </button>
            </a>
          </div>
        </div>

        {/* Group Pricing Card */}
        <div className="relative border border-gray-200 rounded-lg shadow-md flex flex-col">
          <div
            style={{ width: "80%" }}
            className="absolute   lg:-top-20 -top-15 w-[90%] text-center pt-[30px] pb-[20px]  mx-auto left-1/2 -translate-x-1/2 bg-[#2FB57C] z-10  px-6 "
          >
            <h3
              style={{
                fontFamily: "poppins",
                display: "inline-block",
                paddingTop: "8px",
                paddingLeft: "20px",
                paddingRight: "20px",
                alignSelf: "center",
                textAlign: "center",
              }}
              className="text-[14px] rounded-full text-center text-black bg-white p-2"
            >
              For Schools & Daycares
            </h3>
            <div className="flex lg:mt-3  items-center justify-center gap-6">
              <p
                style={{ fontFamily: "Fredoka" }}
                className="lg:text-[54px] text-[28px]  font-semibold text-white"
              >
                {formatter.format(SCHOOL_ANNUAL)}
              </p>
            </div>
            <p className="text-white text-sm mt-2 leading-relaxed">
              Prefer installments? First payment {schoolInstallments.firstPayment}, followed by 11 payments of{" "}
              {schoolInstallments.recurringPayment} (every 30 days).
            </p>
          </div>

          <div
            style={{ width: "80%" }}
            className="mx-auto lg:mt-48 mt-36 pb-6  flex-1 flex flex-col justify-center"
          >
            <div>
              <h4
                style={{ fontFamily: "poppins" }}
                className="font-medium text-black lg:text-[24px] text-[20px] text-lg mb-4"
              >
                What's included:
              </h4>
              <ul className="space-y-6 text-base text-gray-700">
                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Unlimited access for your entire team
                  </div>
                </li>
                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Emergency Management System with tracking dashboard
                  </div>
                </li>

                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Staff certification and automatic recertification alerts
                  </div>
                </li>

                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Compliance documents, SOPs, and protocol handbook
                  </div>
                </li>

                <li className="flex ">
                  <img
                    className="h-[10px] mt-3"
                    src={correct}
                    alt="check"
                  />
                  <div
                    className="ml-3 text-black text-[18px]"
                    style={{ fontFamily: "Poppins" }}
                  >
                    Free emergency plan rewrite to pass licensing inspections
                  </div>
                </li>
              </ul>
            </div>
            <a href={`${process.env.REACT_APP_ADMIN_URL}/schoolregister/school`}>
              <button className="w-full bg-[#F0AA00] hover:bg-yellow-600 text-white font-bold py-3 rounded-md mt-10 text-[19px] transition">
                Sign Up
              </button>
            </a>
          </div>
        </div>
        <div className="absolute top-[calc(50%+25px)] lg:top-[calc(50%-310px)] 2xl:top-[calc(50%-150px)] z-10 right-0 lg:right-[-35px] 2xl:-right-85">
          <a href="/contactUs">
            <img
              src={popup}
              alt="popup"
              className="w-40 sm:w-56  lg:w-65"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
